import 'react-app-polyfill/ie11.js';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { enableES5 } from 'immer';
import {
    overrideComponent,
    postVerificationSizeUpdates,
    setOptions,
} from '@sheerid/jslib';

import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepMemberPersonalInfoComponent } from './components/steps/StepMemberPersonalInfoComponent';
import { marinerNumberValidator } from './lib/validators/customFieldValidators';
import { StepSuccessComponent } from './components/steps/StepSuccessComponent';

overrideComponent('StepMemberPersonalInfoComponent', StepMemberPersonalInfoComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);

marinerNumberValidator();

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
